import React from 'react';
import '../../css/gardenManagerStylings/GardenManagerSidebarQuickActionsStyling.css';

const GardenManagerSidebarQuickActionsComponent = ({ takeSnapshot }) => {
    return (
        <div className={`garden-manager-quick-actions-body`}>
            <div className={`garden-manager-quick-actions-buttons`}>
                <div className={`garden-manager-quick-actions-button remove-plant`}>
                    🗑️ Remove Plant
                </div>

                <div className={`garden-manager-quick-actions-button analytics`}>
                    📊 View Analytics
                </div>

                <div className={`garden-manager-quick-actions-button share-update`}>
                    📤 Share Garden Update
                </div>

                <div className={`garden-manager-quick-actions-button garden-snapshot`}
                     onClick={takeSnapshot}
                >
                    📷 Take Garden Snapshot
                </div>
            </div>
        </div>
    )
}

export default GardenManagerSidebarQuickActionsComponent